export * from './endereco.model';



// WEBPACK FOOTER //
// ./src/app/shared/endereco/index.ts